export default __webpack_public_path__ + "static/media/ticket.6a69c9cf.svg";